import { call, put, takeLatest, all } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { GET_PRODUCT_REQUEST } from 'redux/products/constants';

import { addWish } from './api';
import {
  ALLOCATION_WISH_REQUESTING,
  ADD_ALLOCATION_WISH_REQUEST
} from './constants';

export function* add(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: ALLOCATION_WISH_REQUESTING });
    const response = yield call(
      addWish,
      customerId(),
      action.allocationId,
      action.wish
    );
    yield put({ type: GET_PRODUCT_REQUEST, slug: action.slug });
    action.onSuccess(response.data);
  } catch (error) {
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError();
    }
  }
}

export function* watchList() {
  yield takeLatest(ADD_ALLOCATION_WISH_REQUEST, add);
}

export default function* productSagas() {
  yield all([watchList()]);
}
